import { useState } from "react";
import { Form, Button, Alert } from 'react-bootstrap';
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../utils/config";
import { FaArrowLeft } from "react-icons/fa";

const ResetPasswordForm = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
        } else {
            const response = await fetch(`${baseUrl}/app_api/update-password`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ token, password, currentPassword })
            });

            if (response?.status === 204) {
                setError("Mot de passe incorrect.");
            } if (response?.status === 200) {
                setError("");
                notify("Mot de passe modifier avec succès !.");
                window.location.href = "/login";
            } else {
                notifyError("Erreur lors de la modification du mot de passe.");
            }
        }

    };

    const notifyError = (message: string) => toast.error(message);
    const notify = (message: string) => toast(message);

    return (
        <div className="login-page">
            <div className="login-container-reset-pwd">
                <h2 className="login-title">Changement de mot de passe</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Mot de passe actuel"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Nouveau mot de passe"
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirmer le mot de passe"
                            required
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" className="w-100">
                        Réinitialiser le mot de passe
                    </Button>
                </Form>
                <div className="text-center mt-3">
                    <Link to="/login" className="login-forgot"><FaArrowLeft /> Retour à la connexion</Link>
                </div>
            </div>
        </div>
    )
};

export default ResetPasswordForm;